
const initailState = {
    arr:[],
    nextKey:''
}
const Completedrides=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_COMPLETED_DATA':
            return{ 
                ...state,
                arr: state.arr.concat(action.payload),
                nextKey:action.keynext,
                TotalCount:action.counts
            }
        default:
            return state;
    }
}

export default Completedrides